import { useCallback, useState } from "react";

export interface ColumnFilter<T> {
  id: string;
  value: T;
}
type FilterState<T> = [ColumnFilter<T>, (newValue: T) => void];
export function useFilterState<T>(initialFilter: ColumnFilter<T>): FilterState<T> {
  const [currentFilter, setCurrentFilter] = useState<ColumnFilter<T>>(initialFilter);
  const setFilterValue = useCallback(
    (newValue: T) => setCurrentFilter((old) => ({ id: old.id, value: newValue })),
    [setCurrentFilter],
  );
  return [currentFilter, setFilterValue];
}
